const baseURL = "https://matmasocaivan.com/MMS_api"

const listApi = {
    // Check information
    checkNumber: baseURL + "/number/checkTelNumber",
    checkCCCD: baseURL + "/number/checkPersonalID",
    checkCarNumber: baseURL + "/number/checkcarnumber",
    checkBanking: baseURL + "/number/checkbankingaccount",
    checkGPKD : baseURL + "/number/checkGPKD ",
    checkAddress: baseURL + "/number/checkaddress",

    // export PDF
    exportPDF : baseURL + "/pdf/exportPDFTelNumber",
    carPDF: baseURL + "/pdf/exportPDFCarNumber" ,
    stkPDF : baseURL + "/pdf/exportPDFBankAccount",
    cccdPDF: baseURL + "/pdf/exportPDFPersonalID",
    gplxPDF : baseURL + "/pdf/exportPDFGPKD",

    // UserManagement
    listUser : baseURL + "/user/listUser",
    createUser: baseURL + "/user/createUser",
    deleteUser: baseURL + "/user/deleteUser",
    updateUser: baseURL + "/user/updateUser",

    // Feedback
    feedback: baseURL + "/report/addReport",

    login : baseURL + "/user/login",
    signup: baseURL +"/user/signup",

    // CSM
    listNews: baseURL + "/news/listNews", //ok
    addNews : baseURL + '/news/createNews',
    
    listAllProduct: baseURL+ "/product/listAllProduct", //ok
    addProduct: baseURL +"/product/addProduct",
    editProduct: baseURL + "/product/editProductInfo",
    deleteProduct: baseURL + "/product/deleteProductInfo",
    listProductType : baseURL + '/product/listProductType',
    editTypeProduct: baseURL + '/product/editTypeProduct',
    createTypeProduct: baseURL + '/product/createTypeProduct',
    delTypeProduct: baseURL + "/product/deleteTypeProduct",
    listShipCost: baseURL + "/product/listShipCost",
    delShipCost: baseURL + "/product/deleteShipCost",
    createShipCost: baseURL + "/product/createShipCost",
    editShipCost: baseURL + "/product/editShipCost",

    //Voucher
    listVoucherSealTime: baseURL + "/voucher/listVoucherBySaleTime",
    listMyVoucher: baseURL + "/voucher/listMyVoucher",

    //Order
    newOrder : baseURL + "/order/createNewOrder",
    listAllOrder: baseURL + "/order/listAllOrder",
    listMyOrder : baseURL + "/order/listMyOrder",
    confirmOrder: baseURL + '/order/confirmOrder',
    completeOrder: baseURL + "/order/changeOrderState",
    cancelOrder : baseURL + "/order/cancelOrder",
    addVoucherToUser: baseURL + "/voucher/addVoucherToUser",

    //Transaction 
    listAllTransaction : baseURL + "/transaction/listAllTransaction"
}

export default listApi;